import { IsEnum, IsOptional, IsUUID, IsDateString, IsInt, Min, IsBoolean } from 'class-validator';
import { Type } from 'class-transformer';
import { ChatMessageTargetType } from '../../enums';

export class GetChatMessageListDto {
	@IsUUID('all', { each: true })
	targetIds: string[];

	@IsEnum(ChatMessageTargetType)
	target_type: ChatMessageTargetType;

	@IsOptional()
	@IsDateString()
	before?: string;

	@IsOptional()
	@IsUUID()
	userId?: string;

	@Type(() => Number)
	@IsInt()
	@Min(1)
	limit: number;

	@IsOptional()
	@Type(() => Boolean)
	@IsBoolean()
	isWithoutUserAvatar?: boolean = false;

	@IsOptional()
	@Type(() => Boolean)
	@IsBoolean()
	isReverse?: boolean = false;
}
